import { SSR_SESSION_TOKEN_MONETKA } from '@lentau/core/api/application/ssr-session-token/monetka-ssr-session-token.const';
import { PageType } from '@lentau/ui-kit/core/enums/page-type.enum';
import { UserAuthorizeType } from '@lentau/auth/shared/enums';
import { DeliveryMode } from '@lentau/delivery-mode/shared/enums';
import { EnvironmentBrand, IASFeedOrganizationData } from '@lentau/ui-kit/core/environments/environments.interface';
import {
  BrandsAssets,
  LoyaltyTitle,
  RetailBrands,
  CDNBrands,
  USER_AGREEMENT_ID_ENUM,
  PERSONAL_DATA_ID_ENUM,
  PERSONAL_ACCEPT_ID_ENUM,
  FAQ_ID_ENUM,
  FAQ_ID_ENUM_B2B,
  REFERRAL_ID_ENUM,
  RECCOMENDATION_DATA_ENUM,
  DELETE_ACCOUNT_ID_ENUM,
  ADMON_OFFER_ALIAS,
  RECEIPTS_PRINT_ID_ENUM,
  COUPONS_PRINT_ID_ENUM,
  LOYALTY_PROGRAM_ID_ENUM,
  JURIDICAL_LEGAL_HUB_FAQ_ID_ENUM,
} from '@lentau/ui-kit/core/tokens/constants';

const feeds: IASFeedOrganizationData = {
  [UserAuthorizeType.B2C]: {
    [DeliveryMode.Delivery]: {
      [PageType.Main]: 'default',
      [PageType.Profile]: 'lo-profil-dostavka',
    },
    [DeliveryMode.Pickup]: {
      [PageType.Main]: 'lo-glavnaia-samovyvoz',
      [PageType.Profile]: 'lo-profil-samovyvoz',
    },
  },
  [UserAuthorizeType.B2B]: null,
};

export const environmentBrand: EnvironmentBrand = {
  GTM_TAG_ID: 'GTM-N86MTWN6',
  RETAIL_BRAND: BrandsAssets.MONETKA,
  LOYALTY_TITLE: LoyaltyTitle.MONETKA,
  withCityDomain: true,
  CUSTOM_FEED: feeds,
  IN_APP_HOST_NAME: 'monetka-ru://',
  BRAND: RetailBrands.MONETKA,
  CDN: CDNBrands.MONETKA,
  INFO: {
    USER_AGREEMENT_ID: USER_AGREEMENT_ID_ENUM.MONETKA,
    PERSONAL_DATA_ID: PERSONAL_DATA_ID_ENUM.MONETKA,
    PERSONAL_ACCEPT_ID: PERSONAL_ACCEPT_ID_ENUM.MONETKA,
    FAQ_ID: FAQ_ID_ENUM.MONETKA,
    FAQ_ID_B2B: FAQ_ID_ENUM_B2B.MONETKA,
    REFERRAL_ID: REFERRAL_ID_ENUM.MONETKA,
    LEGAL_INFO_RECOMMENDATION_ID: RECCOMENDATION_DATA_ENUM.MONETKA,
    DELETE_ACCOUNT_ID: DELETE_ACCOUNT_ID_ENUM.MONETKA,
    JURIDICAL_INFO_ID: JURIDICAL_LEGAL_HUB_FAQ_ID_ENUM.MONETKA,
    RECEIPTS_PRINT_ID: RECEIPTS_PRINT_ID_ENUM.MONETKA,
    COUPONS_PRINT_ID: COUPONS_PRINT_ID_ENUM.MONETKA,
    LOYALTY_PROGRAM_ID: LOYALTY_PROGRAM_ID_ENUM.MONETKA,
  },
  ADMON: {
    OFFER_ALIAS: ADMON_OFFER_ALIAS.MONETKA,
  },
  SEARCH_PLACEHOLDER: 'Найти в Монетке',
  HAS_PICKUP: false,
  HAS_ADDRESS_MISSION: false,
  COLORS: {
    PRIMARY: '#003C96',
  },
  SSR_SESSION_TOKEN: SSR_SESSION_TOKEN_MONETKA,
};
